(function () {

  'use strict';

  angular.isUndefinedOrNull = angular.isUndefinedOrNull || function (val) {
    return angular.isUndefined(val) || val === null;
  };

  angular.isExpression = angular.isExpression || function (val) {
    return typeof val === 'string';
  };

  angular.stringContains = angular.stringContains || function (string, val) {
    return string.indexOf(val) !== -1;
  };

})();
